import { Theme, SystemStyleObject } from '@mui/system';

export const dialogBasePaperSx = (theme: Theme): SystemStyleObject => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 1,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  p: 2,
  gap: 2,
});

export const dialogBaseTitleSx = (theme: Theme): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  p: 1,
  '& .MuiSvgIcon-root': {
    width: 20,
    height: 20,
  },
});

export const dialogBaseContentSx = (theme: Theme): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  p: 1,
});

export const dialogBaseActionsSx = (theme: Theme): SystemStyleObject => ({
  gap: 2,
});
